const GetExistDoc = async (props) => { 
    const _res = await props._api({
        ...props,
        method: props.method,
        endpoint: "/api/serviceapi/O2CZ/" + props.type,
        param: "",
        data: props.data,
      });

    return _res;
}

export default GetExistDoc;